// @flow

import React from 'react';
import styles from './styles.scss';

type Props = {
  name: string,
  value: string,
};

const Item = (props: Props) => (
  <div className={styles.item}>
    <span className={styles.name}>{props.name}</span>
    <span className={styles.value}>{props.value}</span>
  </div>
);

export default Item;



// WEBPACK FOOTER //
// ./src/components/Item/index.js